import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import thunk from 'redux-thunk';

import authReducer from '../pages/features/auth/authSlice';
import resourceReducer from '../pages/features/resources/resourceSlice';
import resourceCategoryReducer from '../pages/features/resourcecategory/resourcecategorySlice';
import resourceTagReducer from '../pages/features/resourcetag/resourcetagSlice';
import faqReducer from '../pages/features/faqs/faqSlice';
import faqCategoryReducer from '../pages/features/faqcategory/faqcategorySlice';
import newspapersReducer from '../pages/features/newspapers/newspaperSlice';
import collectionsReducer from '../pages/features/collections/collectionSlice';
import landingPageReducer from '../pages/features/landingpage/landingpageSlice';
import publicReducer from '../pages/features/public/publicSlice';
import userReducer from '../pages/features/users/userSlice'



const reducers = combineReducers({
    auth: authReducer,
    resources: resourceReducer,
    resourceCategory: resourceCategoryReducer,
    resourceTag: resourceTagReducer,
    faqs: faqReducer,
    faqCategory: faqCategoryReducer,
    newspapers: newspapersReducer,
    collections: collectionsReducer,
    landingPage: landingPageReducer,
    publicResources: publicReducer,
    user: userReducer 
});

const persistConfig = {
    key: 'root',
    storage,
    // whitelist: ['auth']
};


const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: [thunk],

}
);